var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown_to_next_event_container"},[(_vm.event_data_needed != '' && _vm.event_data_needed != 'Event has ended')?_c('countdown',{attrs:{"target_date":_vm.countdown_date,"title":_vm.countdown_title}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c7e7e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/countdown/countdown_to_next_event.vue
// module id = 239
// module chunks = 1